module.exports = __webpack_public_path__ + "img/layout-title.0ec137ee.png";